<template>
    <div>
        <navbar1></navbar1>
        <div class="__outsourcebg">
            <div class="container">
                <div class="row">

                    <div class="col-lg-8 col-md-9 col-sm-10">
                        <p class="__welf1">We know that talent is critical. That's where Findworka comes in</p>
                        <p class="__welf2">We host a growing network of verified designers and developers. These verified talents are being matched with companies like yours. to help you build your mission-critical solutions.</p>
                        <!-- <p class="__welf1">Findworka is the future of digital work.</p> -->
                        <!-- <p class="__welf2">We host the largest network of verified developers and lead the digital transformation of enterprises around the world by equipping software talents, startups and enterprises with the project management and productivity tools that they need to build mission-critical solutions.</p> -->
                    </div>
                    <div class="col-lg-4 col-md-3 col-sm-3"></div>
                </div>
            </div>
        </div>

        <div class="__proicon">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9 col-md-9 col-sm-9">
                        <p class="__hirep">Our Story</p>

                        <p class="__hirep1">Findworka helps you recruit pre-vetted tech talents. We also build custom software products by forming high-performance software teams for ambitious organizations.</p>

                        <p class="__hirep1">In 2016, we started out as an online marketplace for artisans, digital services, and gigs, where users could find and connect with freelance experts in Africa. Our model has since evolved to digital services only.</p>
                        <p class="__hirep2">We now</p>
                        <p class="__hirep1">1. Build custom software products for high-growth startups and tech-enabled enterprises. We build web apps, mobile apps, ERP software that can be deployed on premise and in the cloud. We also leverage emerging technologies like blockchain, artificial intelligence and machine learning. </p>
                        <p class="__hirep1">2. Deploy pre-vetted software talents from our Findworka Pro network and open Saucecode community. These developers undergo a two-stage vetting process. </p>
                        <p class="__hirep1">3. Train developers through our Findworka academy.</p>
                        <p class="__hirep1">4. Engage the African tech ecosystem through our various impact programmes. 
                            <ul>
                                <li>Saucecode Hackathon is our annual hackathon. Unlike the regular hackathon that typically takes place during the weekend, this is a 3-month long series of eliminations, a real-time leaderboard display of the top teams and a grand finale where the final five battle to become the winning team.</li>
                                <li>Saucecode Campus Alpha  is our internship network of budding tech stars on different African campuses starting with Nigeria. We identify, train, mentor and place these talents to make them empowered graduates who are ready to take on ICT jobs.</li>
                            </ul>
                        </p>
                        <p class="__hirep1">The Saucecode open community of product designers, developers and tech enthusiasts who will learn, share and collaborate online. </p>
                        <p class="__hirep1">Our mission is to empower today’s companies and workers with the technology and opportunities needed to succeed in the evolving digital economy.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3"></div>
                </div>
            </div>
        </div>

        <div class="container">

            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="__group23"></div>
                    <div class="__group24"></div>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-8">
                    <div class="__group3"></div>
                </div>
            </div>
        </div>

        <div class="__wedobg">
            <div class="container">
                <p class="__wedop">Our Services</p>

                <p class="__wedop1">We do three things extremely well - We supply tech talents, we build apps and we train newbies. </p>
                <!-- <p class="__wedop1">Findworka builds amazing software products, whether it is just an MVP or the nth version of your platform.<br> We also supply development talents for your contract and full-time position.</p> -->
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/outsourcing.png" class="__hidimg">
                        <p class="__hidep">Talent Outsourcing</p>
                        <p class="__hidep1">Our Pros are elite squad of pre-vetted technical talents.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/software-development.png" class="__hidimg">
                        <p class="__hidep"> Software Development</p>
                        <p class="__hidep1"> Whatever web application, or development we have the guys skilled.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/product-design.png" class="__hidimg">
                        <p class="__hidep">UX & Product Design</p>
                        <p class="__hidep1">From screen to screen, we make brilliant designs that tell compelling stories.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <img src="../assets/img/project-management.png" class="__hidimg">
                        <p class="__hidep">Project Management</p>
                        <p class="__hidep1">Take your project from start to finish and ensure that you have a world-class product.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="__prodbg">
            <div class="container">
                <p class="__ourpro">Our Team</p>
                <p class="__ourpro1">Our team is made up of affable and competent people who are passionate about building tech products and helping ambitious people and companies succeed. We are smart, talented, and sure do know how to have fun!</p>
                <p class="__ourpro2">Our mission is to empower today’s companies and workers with the technology and<br>opportunities needed to succeed in the evolving digital economy.<br>- Founder @DeleBaks</p>
                <br><br>

                <div class="row">

                   <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcard">
                            <img src="../assets/img/wilfred.png" class="img-responsive"/>
                            <div class="__prosicons">
                                <a href="https://www.linkedin.com/in/wilfred-ekpo-50256021/" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <!-- <a href="https://twitter.com/wilfred_ekpo" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Wilfred Ekpo</p>

                        <p class="__proicp1">Chief Executive Officer</p>
                    </div>
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcard">

                            <img src="../assets/img/oyin.jpg" class="img-responsive"/>
                            <div class="__prosicons">
                                 <a href="https://www.linkedin.com/in/oyinkansola-subair-0a1b86a0" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <!-- <a href="https://twitter.com/SubairOyin" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Oyinkansola Subair</p>
                        <p class="__proicp1">Finance Manager</p>
                    </div>
                    
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcard">

                            <img src="../assets/img/abimbola.png" class="img-responsive"/>
                            <div class="__prosicons">
                                <a href="https://www.linkedin.com/in/odugbesan-abimbola-310107105/" target="_blank"><i class="fab fa-linkedin"></i></a>
                               <!-- <a href="https://twitter.com/wizubizu" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Abimbola Odugbesan</p>

                        <p class="__proicp1">Front-end Developer</p>
                    </div>
                    
                    
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcard">

                            <img src="../assets/img/Omosefe.jpeg" class="img-responsive"/>
                            <div class="__prosicons">
                                <a href="" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <!-- <a href="https://twitter.com/its_muteehat" target="_blank"><i class="fab fa-twitter"></i></a>-->
                            </div> 
                        </div>
                        <p class="__proicp">Ogbebor Clementina Omosefe</p>
                        <p class="__proicp1">Program Manager</p>
                    </div>
                    
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcard">

                            <img src="../assets/img/ROSE.jpeg" class="img-responsive"/>
                            <div class="__prosicons">
                                <a href="https://www.linkedin.com/in/rose-peter-acipm-mba-55023769" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <!-- <a href="https://twitter.com/sasonxg" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Rose Peters</p>
                        <p class="__proicp1">Human Resources Manager</p>
                    </div>
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcard">

                            <img src="../assets/img/JOEL.jpeg" class="img-responsive"/>
                            <div class="__prosicons">
                                <a href="https://www.linkedin.com/in/joel-olutoye/" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <!-- <a href="https://twitter.com/sasonxg" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Joel Olabode</p>
                        <p class="__proicp1">IT Project Manager</p>
                    </div>
                    
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcard">

                            <img src="../assets/img/modupe.jpeg" class="img-responsive"/>
                            <div class="__prosicons">
                                <a href="https://www.linkedin.com/in/modupe-ariyo?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank"><i class="fab fa-linkedin"></i></a>
                                <!-- <a href="https://twitter.com/realomoibadan" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>

                        <p class="__proicp">Modupe Ariyo</p>
                        <p class="__proicp1">Communications Manager</p>
                    </div>
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcard">
                            <img src="../assets/img/eleazar.png" class="img-responsive"/>
                            <div class="__prosicons">
                                <a href="www.linkedin.com/in/eleazar-edward-94a8ab181" target="_blank"><i class="fab fa-linkedin"></i></a>
                               <!-- <a href="https://twitter.com/realomoibadan" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Edward Eleazar</p>
                        <p class="__proicp1">Full Stack Developer</p>
                    </div>
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcard">
                            <img src="../assets/img/Edima.jpeg" class="img-responsive"/>
                            <div class="__prosicons">
                                <a href="https://www.linkedin.com/in/edima-michael-99844865?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank"><i class="fab fa-linkedin"></i></a>
                               <!-- <a href="https://twitter.com/realomoibadan" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Edima Michael</p>
                        <p class="__proicp1">Admin Manager</p>
                    </div>
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcard">
                            <img src="../assets/img/Micheal.png" class="img-responsive"/>
                            <div class="__prosicons">
                                <a href="https://www.linkedin.com/in/michael-v-8b5676187" target="_blank"><i class="fab fa-linkedin"></i></a>
                               <!-- <a href="https://twitter.com/realomoibadan" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Michael Vigara</p>
                        <p class="__proicp1">Training Manager</p>
                    </div>
                    
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcard">
                            <img src="../assets/img/juwon.png" class="img-responsive"/>
                            <div class="__prosicons">
                                <a href="https://www.linkedin.com/in/yorubaangel/" target="_blank"><i class="fab fa-linkedin"></i></a>
                               <!-- <a href="https://twitter.com/realomoibadan" target="_blank"><i class="fab fa-twitter"></i></a> -->
                            </div>
                        </div>
                        <p class="__proicp">Adekale Olorunjuwonlo Adekunle</p>
                        <p class="__proicp1">Graphics Designer</p>
                    </div>
                </div>

                <!-- <br>
                <p class="__ourpro" style="color: #ffffff;">Board of advisors</p>
                <p class="__ourpro1">We are well-advised by experienced entrepreneurs who are seasoned in various fields and have built<br> successful businesses.</p>

                <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/Bosun_Tijani.jpeg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Dr. Bosun Tijani</p>
                        <p class="__proicp1">Minister of Communications, Innovation and Digital Economy, Nigeria.</p>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/Dr_Nedu.jpeg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Dr Nadu Denloye</p>
                        <p class="__proicp1">Past MD - Telnet</p>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/oluseun-onigbinde.jpeg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Oluseun Onigbinde</p>
                        <p class="__proicp1">Lead Partner, BudgIT</p>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/kolawole-ayeye.jpeg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Kola Ayeye</p>
                        <p class="__proicp1">CEO - GDL</p>
                    </div>
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/dale.png" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Dale Bakare</p>
                        <p class="__proicp1">Founder - Findworka</p>
                    </div>
                    
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4">
                        <div class="__imgcardsp">
                            <img src="../assets/img/Tunde.jpeg" class="img-responsive"/>
                        </div>
                        <p class="__proicp">Tunde Yusuf</p>
                        <p class="__proicp1">Engineering Manager</p>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="container">

            <p class="__ourep">Let's build your project</p>
            <!-- <p class="__ourep">Our projects</p> -->
            <div class="row">
                <div class="col-xl-8 col-lg-8 col-md-9 col-ms-10">
                    <p class="__hirep1">Our clientele comprises some of the most progressive companies across the globe. We work with businesses spanning different sectors but having the same desire - the need for great tech. We listen to ourclients and with distinctive collaboration, transform their big ideas into exceptional products.We work with the best and deliver the best, such that when your product launches, you are guaranteed two things - smiles and satisfaction.</p>
                </div>
            </div>
            <router-link to="/build" class="__sthringlink">Build your product <img src="../assets/img/right-arrow.svg"> </router-link>
        </div>

        <div class="__hirbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-6">
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-3">
                                <i class="__icond1 fas fa-laptop"></i>
                                <!-- <img src="../assets/img/hackathon.png" class="__tesimg"> -->
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-9">
                                <p class="__hirp">Build your product</p>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2"></div>
                            <div class="col-lg-10 col-md-10 col-sm-10">
                                <p class="__hirp1">We know how much your idea means to you. What we do is take those ideas and convert them to world-class software products.</p>
                                <router-link to="/build" class="btn __startbtn">Start now</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2">
                        <div class="__midline hidden-xs"></div>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-6">
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-3">
                                <i class="__icond1 fas fa-code"></i>
                                <!-- <img src="../assets/img/hackathon.png" class="__tesimg"> -->
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-9">
                                <p class="__hirp">Hire a developer</p>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2"></div>
                            <div class="col-lg-10 col-md-10 col-sm-10">
                                <p class="__hirp1">Hire from our network of pre-vetted and handpicked programming talents for your full-time and contract engagements.</p>
                                <a href="https://hire.findworka.com" target="__blank" class="btn __startbtn">Hire a dev</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import navbar1 from '../components/navbar1';


export default {
    components: { navbar1,},
}
</script>

<style scoped>
@import '../assets/css/about';
</style>


// WEBPACK FOOTER //
// src/components/about.vue